<template>
  <div class="page-wrap">
    <router-view></router-view>
  </div>
</template>

<script>
// import { http, organizationApi } from '@app/services/index';
import store from '@app/store';

export default {
  async created() {
    await store.commit('navigation/setUserTree', [
      { title: 'Личный кабинет', name: 'personal-area.main' }
    ]);
  },
  async destroyed() {
    await store.commit('navigation/setUserTree', []);
  }
};
</script>

<style scoped>
.page-wrap {
  min-height: 100%;
  box-sizing: border-box;
  background-color: #F2F1F2;
}
</style>
